import { useLDClient } from '@launchdarkly/react-sdk';
import { useDarklyImpl } from 'integrations/launchDarkly/impl/useDarklyImpl';
import { LaunchDarklyGlobalFlagsContext } from 'integrations/launchDarkly/providers/LaunchDarklyGlobalFlagsContext';
import { GlobalDarklyFlags } from './__generated__/darkly.flags';

export { GlobalDarklyFlags };

/**
 * Hook to get the value of one or more boolean flags from the global LaunchDarkly client.
 * @param flagNames GlobalDarklyFlags.BooleanFlag[] - The names of the boolean flags to retrieve.
 * @returns An object containing the values of the requested boolean flags.
 * @example
 *  const {
 *    invoicing20,
 *    bpDocsAiChatbot
 *  } = useGlobalDarklyBoolean(GlobalDarklyFlags.BooleanFlag.invoicing20, GlobalDarklyFlags.BooleanFlag.bpDocsAiChatbot);
 */
export function useGlobalDarklyBoolean<FLAG_NAME extends GlobalDarklyFlags.BooleanFlag>(...flagNames: FLAG_NAME[]) {
  const client = useLDClient(LaunchDarklyGlobalFlagsContext);

  return useDarklyImpl(client, flagNames, 'boolean');
}
